import React from 'react';
import { Collapse } from 'antd';
import { StrategyPhase } from '../ProfitScenario/types';
import { StrategyPhaseTable } from './StrategyPhaseTable';
import { WeeklyStrategy } from '../ProfitScenario/types';
import { PhaseHeader } from './PhaseHeader';
import { PhaseDescription } from './PhaseDescription';
import { PhaseControls } from './PhaseControls';

const { Panel } = Collapse;

interface StrategyPhaseListProps {
    phases: StrategyPhase[];
    activeKeys: string[];
    handleCollapseChange: (keys: string | string[]) => void;
    landedCost: number;
    fbaFee: number;
    referralRate: number;
    storageFee: number;
    shippingCost: number; // 新增
    updatePhaseInfo: (phaseId: string, updates: any) => void;
    deletePhase: (phaseId: string) => void;
    updateWeekStrategy: (phaseId: string, weekIndex: number, updates: Partial<WeeklyStrategy>) => void;
    addTask: (phaseId: string, weekIndex: number, content: string, priority: 'high' | 'medium' | 'low', startDate: string, endDate: string) => void;
    updateTask: (phaseId: string, weekIndex: number, taskId: string, updates: Partial<{ content: string; priority: 'high' | 'medium' | 'low' }>) => void;
    deleteTask: (phaseId: string, weekIndex: number, taskId: string) => void;
    toggleTaskCompletion: (phaseId: string, weekIndex: number, taskId: string) => void;
    clearCompletedTasks: (phaseId: string, weekIndex: number) => void;
}

export const StrategyPhaseList: React.FC<StrategyPhaseListProps> = ({
    phases,
    activeKeys,
    handleCollapseChange,
    landedCost,
    fbaFee,
    referralRate,
    storageFee,
    shippingCost, // 新增
    updatePhaseInfo,
    deletePhase,
    updateWeekStrategy,
    addTask,
    updateTask,
    deleteTask,
    toggleTaskCompletion,
    clearCompletedTasks
}) => {
    return (
        <Collapse activeKey={activeKeys} onChange={handleCollapseChange}>
            {phases.map((phase) => {
                return (
                    <Panel
                        key={phase.id}
                        header={
                            <PhaseHeader
                                phase={phase}
                                landedCost={landedCost}
                                fbaFee={fbaFee}
                                referralRate={referralRate}
                                storageFee={storageFee}
                                phasesCount={phases.length}
                                updatePhaseInfo={updatePhaseInfo}
                                deletePhase={deletePhase}
                            />
                        }
                    >
                        <PhaseDescription
                            phase={phase}
                            updatePhaseInfo={updatePhaseInfo}
                        />

                        <PhaseControls
                            phase={phase}
                            updatePhaseInfo={updatePhaseInfo}
                        />

                        <StrategyPhaseTable
                            phase={phase}
                            landedCost={landedCost}
                            fbaFee={fbaFee}
                            referralRate={referralRate}
                            storageFee={storageFee}
                            shippingCost={shippingCost}
                            updateWeekStrategy={updateWeekStrategy}
                            addTask={addTask}
                            updateTask={updateTask}
                            deleteTask={deleteTask}
                            toggleTaskCompletion={toggleTaskCompletion}
                            clearCompletedTasks={clearCompletedTasks}
                        />
                    </Panel>
                );
            })}
        </Collapse>
    );
};

